import { DateTime } from 'luxon';

export const toBeFormat = (date: DateTime): string => {
  return date.toUTC().toISO({
    suppressMilliseconds: true,
  });
};
